<template>
    <div class="btn-group menuList" v-bind:class="{ open: isOpen }">
        <a :href="menuList.linkUrl" class="btn btn-default dropdown-toggle mtg" data-bs-toggle="dropdown" role="button" v-if="!menuList.linkList"><b>{{menuList.title}}</b></a>
        <span class="btn btn-default mtg" role="button" v-if="menuList.linkList" v-on:click="toggleMenu" v-touch:swipe.right="toggleMenu"><b>{{menuList.title}}</b></span>
        <ul class="dropdown-menu" v-if="menuList.linkList">
            <MenuItem :item="menuItem" :key="buildKey(menuItem)" v-for="menuItem in menuList.linkList" v-on:ItemClicked="closeMenu"/>
        </ul>
    </div>
</template>

<script>
    import MenuItem from './MenuItem.vue';

    export default {
    components: { MenuItem },
    computed: {
      isOpen() {
        if (this.$store.state.mainMenuState.activeMenuKey === this.menuKey) {
          return true;
        } else {
          return false;
        }
      },
    },
    props: {
      menuList: {
        type: Object,
        default: () => ({}),
      },
      menuKey: {
        type: String,
      },

    },
    methods: {
      buildKey(item) {
        return (Math.random() + '-' + (item.title.replace(/[\W_]+/g, '')));
      },
      closeMenu() {
        this.$emit('CloseAllMenus');
      },
      toggleMenu(selection) {
        this.$emit('toggleSubMenu', (this.isOpen));
        const self = this;
        if (this.$el.classList.contains('open')) {
          this.$emit('clearActiveKey');
        } else {
          this.$emit('CloseAllMenus', { selectedMenuKey: self.menuKey });
        }
      },

    },
  };
</script>

<style>
    .mainMenu .mtg.btn:active {
        background-color: transparent;
        color: #ddd;
    }

    .showMobileMenu .mainMenu .btn-default,
    .showMobileMenu .mainMenu .mtg.btn:active {
        background-color: transparent;
        color: #444;
    }

    .showMobileMenu .mainMenu .dropdown-menu {
        height: 100%;
    }

    @media only screen and (max-width: 1200px) {
        .showMobileMenu .mainMenu .dropdown-menu {
            height: auto;
        }
    }
</style>
